import { useEffect, useLayoutEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import { useNavigate } from "react-router-dom";
import * as theme from "../theme";
import { debounce } from 'lodash';
import {
  getArrayOfProspectsId,
  getClientDetailsUsingProspectId,
  getGettingMyQuotes,
  getGettingMyQuotesSuccess,
  getMyQuotes,
  getStatus,
  // getBrokers,
  getVertical,
  getRowDetailsFromProspectId,
  // getFilteredProspectsIdArray,
  getSearchedProspectsArray,
} from "../store/myquotes";
import { getVerticalList, loadverticals } from "../store/verticals";

import {
    getCustomersTable,
    getMyCustomers,
    
    getGettingMyCustomers,
    gettingCustomersInitialized,
    getSearchedCustomersArray,
    getGettingMyCustomersSuccess,
    searchCustomers,
    getBrokers,
    getFilteredProspectsIdArray
} from "../store/mycustomers";
import Loader3Orange from "../general/Loader3Orange";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
  storeProspectid,
} from "../store/quotes";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import { PossibleClientDetailsStatus } from "../store/helperfuncs";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import {
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import {  getBrokerInformation } from "../store/broker";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-dropdown-select";
import WhiteTextField from "../general/TextFieldCustomized";
import ActionButton from "../general/ActionButton";

const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

// Translation object for MyCustomers components
const translation = {
  'en' : {
    'backApp': 'Back to Home Page',
    'heading1': 'Your Customers',
    'heading2' : 'Filter below, or scroll through all your client activity',
    'review': 'Review',
    'filters': 'Filters',
    'searchProspect': 'Search for a prospect',
    'date': 'Date',
    'from': 'From',
    'to': 'To',
    'status': 'Status',
    'vertical': 'Vertical',
    'broker': 'Broker',
    'clearFilters': 'Clear Filters',
    'detailsView': 'Details View',
    'yourProspects': 'Your Prospects',
    'prospectFilterDesc': 'Filter below, or scroll through all your client activity',
    'errorCustomers': 'Something failed getting your customers, please contact admin.',
    'thisWeek': 'This Week',
    'thisMonth': 'This Month',
    'thisYear': 'This Year',
    'custom': 'Custom',
    'prospect': 'Prospect',
    'customer': 'Customer',
    'statusNew': 'New',
    'statusAppInProgress': 'App In Progress',
    'statusAppCompleted': 'App Completed',
    'statusInMarket': 'In Market',
    'statusQuoted': 'Quoted',
    'statusSold': 'Sold',
    'statusCloseIncomplete': 'Close - Incomplete Info',
    'statusCloseNoInsurer': 'Close - No Insurer',
    'statusNotInterested': 'Not Interested',
  },
  'fr' : {
    'backApp': 'Retour à la page d\'accueil',
    'heading1': 'Vos clients',
    'heading2': 'Filtrez ci-dessous ou parcourez toute l\'activité de vos clients',
    'review': 'Consulter',
    'filters': 'Filtres',
    'searchProspect': 'Rechercher un client potentiel',
    'date': 'Date',
    'from': 'De',
    'to': 'À',
    'status': 'Statut',
    'vertical': 'Vertical',
    'broker': 'Courtier',
    'clearFilters': 'Effacer les filtres',
    'detailsView': 'Vue détaillée',
    'yourProspects': 'Vos clients potentiels',
    'prospectFilterDesc': 'Filtrez ci-dessous ou parcourez toute l\'activité de vos clients',
    'errorCustomers': 'Échec de la récupération de vos clients, veuillez contacter l\'administrateur.',
    'thisWeek': 'Cette semaine',
    'thisMonth': 'Ce mois-ci',
    'thisYear': 'Cette année',
    'custom': 'Personnalisé',
    'prospect': 'Client potentiel',
    'customer': 'Client',
    'statusNew': 'Nouveau',
    'statusAppInProgress': 'Demande en cours',
    'statusAppCompleted': 'Demande complétée',
    'statusInMarket': 'Sur le marché',
    'statusQuoted': 'Soumis',
    'statusSold': 'Vendu',
    'statusCloseIncomplete': 'Fermé - Info incomplète',
    'statusCloseNoInsurer': 'Fermé - Pas d\'assureur',
    'statusNotInterested': 'Pas intéressé',
  }
}

const MyCustomers = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mycustomers })
    );
  }, [dispatch]);
  const [query, setQuery] = useState("");
  const [brokerFilter, setBrokerFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [verticalFilter, setVerticalFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [showBoardView, setBoardViewVisbility] = useState(false);
  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        <TwoPanesPanel
          myquotesscreen={true}
          overflowY={"none"}
          myquotesleftpane={
            showBoardView ? (
              <BoardView
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
                
              />
            ) : (
              <MyQuotesLeftPane
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
                overflowY={"None"}
              />
            )
          }
          myquotesrightpane={
            <MyQuotesRightPane
              setQuery={setQuery}
              query={query}
              startDateFilter={startDateFilter}
              endDateFilter={endDateFilter}
              setBrokerFilter={setBrokerFilter}
              setStatusFilter={setStatusFilter}
              setVerticalFilter={setVerticalFilter}
              setStartDateFilter={setStartDateFilter}
              setEndDateFilter={setEndDateFilter}
            />
          }
        ></TwoPanesPanel>
      </MainPane>
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const MyQuotesLeftPane = (props) => {
  let heightDivison = {
    backtoapp: "5%",
    quoteresults: "11%",
    tableheader: "7vh",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  const broker = useSelector(getBrokerInformation);
	const languagecode = broker?.information?.languagepreference || "en";

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";

  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      leftMargin={"5vw"}
      backToApplication={
        <BackToApplication
          text={translation[languagecode].backApp}
          onClick={() => {
            document.location.href = `/`;
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={translation[languagecode].heading1}
            heading2={translation[languagecode].heading2}
          ></TwoHeading>
          {/* <OrangeButton
            onClick={() => props.setBoardViewVisbility(true)}
            width="12.5vw"
            fontSize="2vh"
            text="Board View"
          /> */}
        </div>
      }
      tableHeaderSection={<MyCustomersTableHeader></MyCustomersTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <MyQuotesRowsSection heightDivison={heightDivison}>
          <MyQuotesEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
          ></MyQuotesEachRow>
        </MyQuotesRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const SomethingFailedGettingMyQuotes = () => {
  return <div>Something failed getting your customers, please contact admin.</div>;
};

const MyQuotesRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyQuotesInitialized = useSelector(getGettingMyCustomers);
  const gettingMyQuotesSucceed = useSelector(getGettingMyCustomersSuccess);
  //console.log("Ram");
  //console.log(gettingMyQuotesInitialized);
  //console.log(gettingMyQuotesSucceed);
  useEffect(() => {
    console.log("Calling getMyCustomers")
    dispatch(getMyCustomers());
    console.log(gettingMyQuotesInitialized);
  }, [dispatch]);

  useEffect(() => {
    console.log(gettingMyQuotesSucceed)
    console.log(gettingMyQuotesInitialized)
  }, [gettingMyQuotesSucceed, gettingMyQuotesInitialized]);

  return (
    <>
      {gettingMyQuotesInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyQuotesSucceed ? (
        props.children
      ) : (
        <SomethingFailedGettingMyQuotes></SomethingFailedGettingMyQuotes>
      )}
    </>
  );
};

const MyQuotesEachRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const customerTableFull = useSelector(getCustomersTable);
  //console.log(customerTable)
  const customerfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects,
      props.query
    )
  );
  let customerTable = customerfilteredorder;
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();
  const itemsPerPage = 10;
  const maxPages = 10;

  // Logic for displaying page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(customerTable.length / itemsPerPage);
  const arrPageLimiter = [totalPages, maxPages];
  for (let i = 1; i <= Math.min(...arrPageLimiter); i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    if(currentPage > totalPages){
      setCurrentPage(1);
    }
  }, [customerfilteredorder, totalPages])

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
        display:"flex",
        flexDirection:"column",
        flex: 1,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          // overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {customerTable.map((customer, x) =>
          x >= (currentPage - 1) * itemsPerPage &&
          x < currentPage * itemsPerPage ? (
            <CustomerRow key={customer.prospectids[0]} customer={customer}></CustomerRow>
          ) : null
        )}
      </div>
      <div>
        <ul className="pagination justify-content-center">
          {pageNumbers.map((x) => (
            <li
              key={x}
              className={x === currentPage ? "page-item active" : "page-item"}
            >
              <a
                className="page-link"
                onClick={() => {
                  setCurrentPage(x);
                }}
              >
                {x}
              </a>
            </li>
          ))}
          {totalPages > maxPages ? (
            <li
              key={totalPages}
              className={
                totalPages === currentPage ? "page-item active" : "page-item"
              }
            >
              <input
                className="page-link"
                style={{ width: "80px" }}
                placeholder={".." + totalPages}
                type="number"
                min="1"
                max={totalPages}
                onChange={(event) => {
                  setCurrentPage(event.target.value);
                }}
              ></input>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

const ProspectRow = ({ prospectid }) => {
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const languagecode = useSelector(getLanguageCode);

  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const dispatch = useDispatch();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        // height: "60px",
        maxHeight: "100px",
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.brokername}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Business_name}
        ></ClientDetailsGeneral>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.vertical[languagecode]}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Name}
        ></ClientDetailsGeneral>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        <a
          href={
            "tel:" +
            prospectDetails.clientdetails[Client_Contact]?.replace(
              /[^0-9]+/g,
              ""
            )
          }
        >
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Contact}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        <a href={"mailto:" + prospectDetails.clientdetails[Client_Email]}>
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Email}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.status}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        <FormateDate millliseconds={prospectDetails.lastupdated}></FormateDate>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        <OrangeButton
          text={translation[languagecode].review}
          color={theme.COLORS.primary_navyblue}
          width={"0vmin"}
          height={"78%"}
          onClick={() => {
            dispatch(storeProspectid(prospectid));
            document.location.href = `/prospect?id=${prospectid}`;
          }}
        ></OrangeButton>
      </div>
    </div>
  );
};

const CustomerRow = ({ customer }) => {
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker?.information?.languagepreference || "en";

    // console.log(key)
    //console.log(customer)
    let history = useNavigate();
    var prospectid = null
    const prospectDetails = useSelector(
      getRowDetailsFromProspectId({ prospectid })
    );
    const searchedProspects = useSelector(getSearchedProspectsArray);

    const ColoumnWidth = theme.columnWidthMyQuotesTable;
    ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  
    const commonStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    };
  
    const borderCommon = {
      borderRight: "1px solid #D8D8D8",
    };
    const customerDetails = {
      name: customer?.name ?? customer?.contacts?.[0]?.name ?? '',
      phone: customer?.phone ?? customer?.contacts?.[0]?.phone ?? '',
      email: customer?.email ?? customer?.contacts?.[0]?.email ?? ''
    };

    const { name, phone, email } = customerDetails;

    const useStyles = makeStyles((themex) => ({
      tableDiv: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          flex:1,
          borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
          borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
          backgroundColor: "white",
          minHeight: "6vh",
          // When screen height <= 800px
          "@media (max-height: 800px)": {
            maxHeight: "5vh",
          },
          // When screen height <= 700px
          "@media (max-height: 700px)": {
            maxHeight: "4.5vh",
          },
          // When screen height <= 600px
          "@media (max-height: 600px)": {
            maxHeight: "4vh",
          },

      }
    }))
    const dispatch = useDispatch();
    console.log(customer)
    let producer = customer.teammembers?.[0]?.name;
    let servicer = customer.teammembers?.[1]?.name ?? customer.teammembers?.[0]?.name
    let emailFontSize = '';
    const classes = useStyles();
    return (
      <div
        className={classes.tableDiv}
      >
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.first,
            ...borderCommon,
          }}
        >
          <NormalText
            text={ name }
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          ></NormalText>
        </div>
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.second,
            ...borderCommon,
          }}
        >
          <a
            href={
              "tel:" +
                phone?.replace(
                /[^0-9]+/g,
                ""
              )
            }
          >
           <NormalText
            text={ phone }
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          ></NormalText>
          </a>
        </div>
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.third,
            ...borderCommon,
            wordBreak:'break-word'
          }}
        >
          <a href={"mailto:" + email}>
            <NormalText
              text={ email }
              fontWeight={"normal"}
              fontSize={15}
              color="grey"
            />
          </a>
        </div>
        
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.fourth,
            ...borderCommon,
          }}
        >
          <ClientDetailsGeneral
            prospectDetails={customer}
            ClientDetailPartName={"company"}
          ></ClientDetailsGeneral>
        </div>
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.fifth,
            ...borderCommon,
          }}
        >
          <ClientDetailsGeneral
            prospectDetails={customer}
            ClientDetailPartName={"status"}
            calculatedText={customer.isbinded ? translation[languagecode].customer : translation[languagecode].prospect}
          ></ClientDetailsGeneral>
        </div>
        
        
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.sixth,
            ...borderCommon,
          }}
        >
          <NormalText
            text={producer}
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          />
        </div>
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.seventh,
            ...borderCommon,
          }}
        >
          <NormalText
            text={servicer}
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          />
        </div>
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.eighth,
            ...borderCommon,
          }}
        >
          <NormalText
            text={customer?.bms}
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          ></NormalText>
        </div>
        
        <div
          style={{
            ...commonStyle,
            width: ColoumnWidth.ninth,
          }}
        >
          <OrangeButton
            text={translation[languagecode].review}
            color={theme.COLORS.primary_navyblue}
            width={"0vmin"}
            height={"78%"}
            maxheight={"3vmin"}
            onClick={() => {
              dispatch(storeProspectid(prospectid));
              //document.location.href = `/customer?id=${customer._id}`;
              
              history(`/customer?id=${customer._id}`)
            }}
          ></OrangeButton>
        </div>
      </div>
    );
};

const FormateDate = ({ millliseconds }) => {
  let date = new Date(millliseconds);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY");
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};
const ClientDetailsGeneral = ({
  prospectDetails,
  ClientDetailPartName,
  textColor,
  fontSize,
  calculatedText
}) => {
  const [show, setShow] = useState(false);
  if (!textColor) textColor = "grey";
  if (!fontSize) fontSize = 15;
  let text = calculatedText ? calculatedText : prospectDetails[ClientDetailPartName];
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(timeout);
  });

  return (
    <>
      {show ? (
        <NormalText
          text={text}
          fontWeight={"normal"}
          fontSize={fontSize}
          color={textColor}
        ></NormalText>
      ) : (
        ""
      )}
    </>
  );
};

const MyQuotesTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;

  const columnHeadingsQuotes = {
    first: "Broker",
    second: "Client",
    third: "Vertical",
    fourth: "Contact Name",
    fifth: "Contact Number",
    sixth: "Contact Email",
    seventh: "Status",
    eighth: "Last Update",
    ninth: "Review Details",
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};
//#endregion

const MyCustomersTableHeader = (props) => {
    const ColoumnWidth = theme.columnWidthMyQuotesTable;
    ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
    let BrokerInfo = useSelector(getBrokerInformation);
    const languagepreference = BrokerInfo.information.languagepreference;
    const columnHeadingsQuotes = 
    {
      'en': {
        first: "Name",
        second: "Phone",
        third: "Email",
        fourth: "Company",
        fifth: "Status",
        sixth: "Producer",
        seventh: "Servicer",
        eighth: "BMS Code",
        ninth: "Review Details",
      },
      'fr': {
        first: "Nom",
        second: "Téléphone",
        third: "Email",
        fourth: "Entreprise",
        fifth: "Statut",
        sixth: "Producteur",
        seventh: "Agent de service",
        eighth: "Code client",
        ninth: "Détails de l'examen",
      }
    };
  
    const CommonStyleColumn = {
      color: "white",
      fontFamily: "GibsonRegular",
      alignSelf: "center",
      borderRight: `1px solid ${theme.COLORS.table_header_border}`,
      height: "100%",
      display: "flex",
      alignItems: "center",
      letterSpacing: 1,
      justifyContent: "center",
      textAlign: "center",
      fontSize: "1.5vmin",
    };
    const BorderRaidus = 8;
    const headingStyle = {
      height: "100%",
      width: "100%",
      maxHeight:"6vh",
      backgroundColor: theme.COLORS.secondary_skyblue,
      borderTopLeftRadius: BorderRaidus,
      borderTopRightRadius: BorderRaidus,
      display: "flex",
      flexDirection: "row",
    };
  
    return (
      <div style={headingStyle}>
        <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].first}
        </div>
        <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].second}
        </div>
        <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].third}
        </div>
        <div
          style={{
            width: ColoumnWidth.fourth,
            ...CommonStyleColumn,
          }}
        >
          {columnHeadingsQuotes[languagepreference].fourth}
        </div>
        <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].fifth}
        </div>
        <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].sixth}
        </div>
        <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].seventh}
        </div>
        <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
          {columnHeadingsQuotes[languagepreference].eighth}
        </div>
  
        <div
          style={{
            width: ColoumnWidth.ninth,
            ...CommonStyleColumn,
            borderRight: 0,
          }}
        >
          {columnHeadingsQuotes[languagepreference].ninth}
        </div>
      </div>
    );
};
  //#endregion

const BoardView = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";

  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      backToApplication={
        <BackToApplication
          text={"Back to Home Page"}
          onClick={() => {
            document.location.href = `/`;
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={"Your Prospects"}
            heading2={
              "Filter below, or scroll through all your client activity"
            }
          ></TwoHeading>
          <OrangeButton
            onClick={() => props.setBoardViewVisbility(false)}
            width="12.5vw"
            fontSize="2vh"
            text="Details View"
          />
        </div>
      }
      tableHeaderSection={<BoardTableHeader></BoardTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <BoardRowsSection heightDivison={heightDivison}>
          <BoardEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
          ></BoardEachRow>
        </BoardRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const BoardTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyQuotesTable;

  const columnHeadingsQuotes = {
    first: "New",
    second: "App In Progress",
    third: "App Completed",
    fourth: "In Market",
    fifth: "Quoted",
    sixth: "Sold",
    seventh: "Close - Incomplete Info",
    eighth: "Close - No Insurer",
    ninth: "Not Interested",
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};

const BoardRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyQuotesInitialized = useSelector(getGettingMyCustomers);
  const gettingMyQuotesSucceed = useSelector(getGettingMyCustomersSuccess);

  useEffect(() => {
    console.log("getMyCustomers3")
    dispatch(getMyCustomers(null));
  }, [dispatch]);

  return (
    <>
      {gettingMyQuotesInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyQuotesSucceed ? (
        props.children
      ) : (
        <SomethingFailedGettingMyQuotes></SomethingFailedGettingMyQuotes>
      )}
    </>
  );
};

const BoardEachRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const prospectfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects,
      props.query
    )
  );
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();

  const classes = useStyles();

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {prospectfilteredorder.slice(0, 100).map((prospectid, index) => (
          <BoardRow key={index} prospectid={prospectid}></BoardRow>
        ))}
      </div>
    </div>
  );
};

const BoardRow = ({ prospectid }) => {
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const languagecode = useSelector(getLanguageCode);

  const ColoumnWidth = theme.columnWidthMyQuotesTable;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (
      prospectDetails.clientdetails === PossibleClientDetailsStatus.notstarted
    )
      dispatch(getClientDetailsUsingProspectId({ prospectid }));
  }, [searchedProspects]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        //height: "60px",
        maxHeight: "75px",
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "new" || prospectDetails.status == "New" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App In Progress" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App Completed" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "In market" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Quoted" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Sold" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - Incomplete Info" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - No Insurer" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        {prospectDetails.status == "Not Interested" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

//#region Right Pane
const MyQuotesRightPane = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const useStyles = makeStyles({
    datePicker: {
      "& .MuiInputBase-root": {
        padding: 0,
        backgroundColor: "#ffffff",
        width: "12.5vw",
        "& .MuiButtonBase-root": {
          padding: 0,
          paddingRight: 10,
          backgroundColor: "#ffffff",
        },
        "& .MuiInputBase-input": {
          padding: 10,
          paddingLeft: 10,
          backgroundColor: "#ffffff",
        },
      },
    },
  });
  const classes = useStyles();

  const brokers = useSelector(getBrokers);
  const statuses = useSelector(getStatus);
  const verticals = useSelector(getVertical);
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference;
  const options = [
    { value: "week", label: translation[languagecode].thisWeek },
    { value: "month", label: translation[languagecode].thisMonth },
    { value: "year", label: translation[languagecode].thisYear },
    { value: "custom", label: translation[languagecode].custom },
  ];
  const boptions = [];
  const debouncedSetQuery = useCallback(
    debounce((value) => {
      props.setQuery(value);
    }, 500),
    [props.setQuery]
  );
  for (const b of brokers) {
    boptions.push({ value: b, label: b });
  }
  const soptions = [{ value: "prospect", label: translation[languagecode].prospect },{ value: "customer", label: translation[languagecode].customer }];
  // for (const b of statuses) {
  //   soptions.push({ value: b, label: b });
  // }
  const voptions = [];
  const uniquevs = [];
  for (const b of verticals) {
    if (!uniquevs.includes(b[languagecode])) {
      uniquevs.push(b[languagecode]);
      voptions.push({ value: b[languagecode], label: b[languagecode] });
    }
  }
  const verticalsInfos = useSelector(getVerticalList);
  const [isCustomDate, setIsCustomDate] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: "3vw",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "GibsonLight",
        color: "grey",
      }}
    >
      <div>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 26,
            color: theme.COLORS.primary_navyblue,
          }}
        >
          {translation[languagecode].filters}
        </Typography>
      </div>
      {loading ? (
        <div
          style={{
            width: "100%",
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : (
        <div />
      )}
      <FormControl sx={{ m: 0, minWidth: 260 }} style={{ marginTop: "20px" }}>
        <div>
          <input
            id="txtQuery"
            placeholder={translation[languagecode].searchProspect}
            style={{
              backgroundColor: "#ffffff",
              width: "80%",
              display: "inline-flex",
              borderStartEndRadius: "0px",
              borderEndEndRadius: "0px",
            }}
            className="form-control"
            onChange={(event) => {
              // props.setQuery(event.target.value);
              debouncedSetQuery(event.target.value);
            }}
          />
          <div
            style={{
              display: "inline-flex",
              paddingLeft: "3.5%",
              paddingTop: "6px",
              paddingRight: "3.5%",
              backgroundColor: theme.COLORS.secondary_orange,
              borderStartEndRadius: "5px",
              borderEndEndRadius: "5px",
            }}
          >
            <label
              onClick={(event) => {
                return; // prevent save from doing anything
                setLoading(true);
                dispatch(searchCustomers(props.query)).then(() =>
                  setLoading(false)
                );
              }}
            >
              🔍
            </label>
          </div>
        </div>
      </FormControl>
      <div style={{ marginTop: "20px", display: "none" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translation[languagecode].date}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={options}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={function (e) {
              var today = new Date();
              var pastWeek = new Date();
              var pastMonth = new Date();
              var pastYear = new Date();
              pastWeek.setDate(pastWeek.getDate() - 7);
              pastMonth.setDate(pastMonth.getDate() - 30);
              pastYear.setDate(pastYear.getDate() - 365);
              if (e[0].value == "week") {
                props.setStartDateFilter(pastWeek);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value == "month") {
                props.setStartDateFilter(pastMonth);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value == "year") {
                props.setStartDateFilter(pastYear);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value == "custom") setIsCustomDate(true);
            }}
          />
        </FormControl>
        <div style={{ width: "250px" }}>
          {isCustomDate ? (
            <div>
              <div>
                <p style={{ margin: "0px", marginTop: "5px" }}>{translation[languagecode].from}</p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.startDateFilter}
                    format="MMM dd, yyyy"
                    onChange={function (e) {
                      props.setStartDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div>
                <p style={{ margin: "0px" }}>{translation[languagecode].to}</p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.endDateFilter}
                    minDate={props.startDateFilter}
                    format="MMM dd, yyyy"
                    onChange={function (e) {
                      props.setEndDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translation[languagecode].status}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={soptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={function (e) {
              props.setStatusFilter(e[0].value);
            }}
          ></Select>
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translation[languagecode].vertical}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={voptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={function (e) {
              let verticalInfo_ = verticalsInfos.find(x => x.name?.en == e[0].value);
              if(verticalInfo_?.id){
                props.setVerticalFilter(verticalInfo_.id);
              }
            }}
          ></Select>
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translation[languagecode].broker}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={boptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={function (e) {
              props.setBrokerFilter(e[0].value);
            }}
          ></Select>
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <OrangeButton
          text={translation[languagecode].clearFilters}
          width="12.5vw"
          onClick={(e) => {
            // props.setBrokerFilter("");
            // props.setStatusFilter("");
            // props.setVerticalFilter("");
            // props.setQuery("");
            // props.setStartDateFilter(null);
            // props.setEndDateFilter(null);
            window.location.reload(false);
          }}
        />
      </div>
    </div>
  );
};

export default MyCustomers;
